import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import axios from 'axios'
import Cookies from "js-cookie";

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        isLoggedIn: !!localStorage.getItem("token"),
        userType: localStorage.getItem('userType'),
        userData: {},
        uType: null,


        menus: [],
        initial: "",
        appLoading: false
    },
    mutations: {
        setuType(state, uType) {
            state.uType = uType;
        },
        userData(state, item) {
            state.userData = item
        },
        setRole(state, role) {
            state.role = role;
        },
        setUsername(state, username) {
            state.username = username;
        },

        sessionOut(state) {
            localStorage.removeItem("token");
            Cookies.remove("refreshToken");
            state.isLoggedIn = false;
            router.push("/login");
        },
        // logoutUser(state) {
        //     axios({
        //         method: "GET",
        //         url: "/logout/",
        //         headers: {
        //             "token": localStorage.getItem("token")
        //         }
        //     }).then(response => {
        //         if (response.data) {
        //             state.isLoggedIn = false
        //             state.userData = {}
        //             state.initial = "";
        //             localStorage.removeItem("token");
        //             localStorage.clear();
        //             router.push('/')
        //         }
        //     })
        // },
        logoutUser(state) {
            // Step 1: Authenticate token
            axios({
                method: "GET",
                url: "/token/authenticate",
                headers: {
                    "token": localStorage.getItem("token")
                }
            }).then(authResponse => {
                if (!authResponse.data.status) {
                    // Step 2: Try to refresh token if authentication fails
                    const refreshToken = Cookies.get('refreshToken');
                    if (refreshToken) {
                        axios({
                            method: "POST",
                            url: "/refresh-token",
                            data: { refreshToken }
                        }).then(refreshResponse => {
                            if (refreshResponse.data && refreshResponse.data.token) {
                                // Update token and proceed to logout
                                localStorage.setItem("token", refreshResponse.data.token);
                                // Step 3: Call logout with new token
                                axios({
                                    method: "GET",
                                    url: "/logout/",
                                    headers: {
                                        "token": refreshResponse.data.token
                                    }
                                }).then(response => {
                                    if (response.data) {
                                        state.isLoggedIn = false;
                                        state.userData = {};
                                        state.initial = "";
                                        localStorage.removeItem("token");
                                        Cookies.remove("refreshToken");
                                        router.push('/login');
                                    }
                                });
                            } else {
                                // If refresh fails, clear session
                                localStorage.removeItem("token");
                                Cookies.remove("refreshToken");
                                state.isLoggedIn = false;
                                router.push('/login');
                            }
                        }).catch(() => {
                            localStorage.removeItem("token");
                            Cookies.remove("refreshToken");
                            state.isLoggedIn = false;
                            router.push('/login');
                        });
                    } else {
                        // No refresh token, clear session
                        localStorage.removeItem("token");
                        Cookies.remove("refreshToken");
                        state.isLoggedIn = false;
                        router.push('/login');
                    }
                } else {
                    // Step 3: Token is valid, proceed to logout
                    axios({
                        method: "GET",
                        url: "/logout/",
                        headers: {
                            "token": localStorage.getItem("token")
                        }
                    }).then(response => {
                        if (response.data) {
                            state.isLoggedIn = false;
                            state.userData = {};
                            state.initial = "";
                            localStorage.removeItem("token");
                            Cookies.remove("refreshToken");
                            router.push('/login');
                        }
                    });
                }
            }).catch(() => {
                // On error, clear session
                localStorage.removeItem("token");
                Cookies.remove("refreshToken");
                state.isLoggedIn = false;
                router.push('/login');
            });
        },
        role(state, item) {
            state.role = item
        },
        loginUser(state, payload) {
            localStorage.setItem("token", payload);
            state.isLoggedIn = true
        },

    },

})